
<template>
    <myDialog 
        :isDialog="dialogVisible" 
        :title="title" 
        :width="'1200px'"
        @handleClose="handleClose"
    >
        <template slot="content">
            <!-- 培训项目列表-->
            <div class="detail-content">
                <myTableSearch 
                    :isOperate="false" 
                    :formData="formData"
                    :tableLabel="tableLabel"
                    :queryFn="queryFn"
                    :queryParams="queryParams"
                    @successQuery="successQuery" 
                    :searchColLg="6" 
                    ref="tableRef" 
                    :isTool="false"
                    :isIndex="true"
                    :isPagination="false"
                >
                    <template slot="levelName" slot-scope="{ row }">
                        <el-tag 
                            :style="getLevelTagStyle(row.levelName)"
                            size="small"
                            effect="plain"
                        >
                            {{ row.levelName || '-' }}
                        </el-tag>
                    </template>
                </myTableSearch>
            </div>
        </template>
        
        <!-- 底部按钮（可选） -->
        <template slot="footer">
            <div class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <!-- 可以添加其他操作按钮 -->
                <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
            </div>
        </template>
    </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingInstitutionTrainingProgramList } from '@/api/training'
export default {
name: 'trainingProgram',
props: {
    isDialog: {
        type: [String, Boolean],
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    institutionId:{
        type: String,
        default:""
    }
},
data() {
    return {
        dialogVisible: false, // 控制弹窗显示
        currentInstitutionId: '', // 当前统一社会信用代码
        formData: [
            {
                type: 'input',
                label: '',
                key: 'keyword',
                placeholder: '请输入培训项目名称、统一社会信用代码',
                colLg: 16,
            }
        ], // 搜索表单数据（空数组，不需要搜索功能）
        queryParams: {},
        tableLabel: [
            {
                prop: 'institutionId',
                label: '统一社会信用代码',
                minWidth: 200
            },
            {
                prop: 'institutionName',
                label: '机构名称',
                minWidth: 300
            },
            {
                prop: 'projectName',
                label: '项目名称',
                minWidth: 120
            },
            {
                prop: 'levelName',
                label: '等级',
                minWidth: 150
            }
        ],
    }
},
methods: {
    // 打开弹窗
    openDialog(row) {
        this.dialogVisible = true
        // 优先使用传入的 row 参数中的 institutionId，如果没有则使用 props
        const id = (row && row.institutionId) ? row.institutionId : this.institutionId
        if (id) {
            this.loadTrainingProgramData(id)
        } else {
            // 如果没有 id，等待 props 更新后再加载
            this.$nextTick(() => {
                if (this.institutionId) {
                    this.loadTrainingProgramData(this.institutionId)
                }
            })
        }
    },
    
     // 关闭弹窗
     handleClose() {
        this.dialogVisible = false
        this.currentInstitutionId = ''
        // 可以通知父组件弹窗已关闭
        this.$emit('dialog-closed')
    },
    
    // 查询函数 - 供myTableSearch组件调用
    queryFn(queryParams) {
        // 从 queryParams.query 中提取查询条件（myTableSearch 组件会将表单数据放在 query 中）
        const query = queryParams.query || {}
        
        // 合并统一社会信用代码和查询条件到查询参数
        const params = {
            ...query,
            institutionId: this.currentInstitutionId
        }
        
        return getTrainingInstitutionTrainingProgramList(params).then(res => {
            // 处理响应数据格式，不需要分页，直接返回数组
            if (res && res.code === 200 && res.data) {
                // 如果data是数组，直接返回
                if (Array.isArray(res.data)) {
                    return {
                        ...res,
                        data: res.data
                    }
                }
                // 如果data是对象且有rows属性，返回rows数组
                if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && res.data.rows) {
                    return {
                        ...res,
                        data: res.data.rows
                    }
                }
            }
            return res
        })
    },
    
    // 查询成功回调
    successQuery(data) {
        // 可以在这里处理查询成功后的逻辑
        console.log('培训项目列表查询成功', data)
    },
    
    //加载数据列表
    async loadTrainingProgramData(institutionId) {
        this.currentInstitutionId = institutionId
        // 触发表格刷新
        this.$nextTick(() => {
            if (this.$refs.tableRef) {
                this.$refs.tableRef.initTableData({}, false)
            }
        })
    },
    
    // 获取等级标签样式
    getLevelTagStyle(levelName) {
        if (!levelName) {
            return {
                backgroundColor: '#1A0263B7',
                color: '#0263B7',
                border: 'none'
            }
        }
        
        const level = String(levelName)
        
        if (level.includes('高级')) {
            return {
                backgroundColor: 'rgba(255, 200, 81, 0.1)',
                color: '#FFC851',
                border: 'none'
            }
        } else if (level.includes('中级')) {
            return {
                backgroundColor:'rgba(0, 201, 253, 0.1)' ,
                color: '#00C9FD',
                border: 'none'
            }
        } else if (level.includes('初级')) {
            return {
                backgroundColor: 'rgba(32, 201, 128, 0.1)',
                color: '#00C9FD',
                border: 'none'
            }
        } else {
            return {
                backgroundColor: 'rgba(2, 99, 183, 0.1)',
                color: '#0263B7',
                border: 'none'
            }
        }
    },

},
// 监听父组件传递的isDialog变化（如果使用props控制）
watch: {
    isDialog: {
        handler(newVal) {
            // 如果isDialog是Boolean类型
            if (typeof newVal === 'boolean') {
                this.dialogVisible = newVal
            }
            // 如果isDialog是String类型（例如："true-机构基本信息"）
            else if (typeof newVal === 'string') {
                this.dialogVisible = newVal.includes('true')
            }
        },
        immediate: true
    }
}
}
</script>


<style lang="scss" scoped>
.myDialog {
/deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--vt-c-blue)!important;
}
        
/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}
        
/deep/ .el-dialog__headerbtn {
    filter: brightness(0) invert(1) !important;
}
}

.detail-content {
    width: 100%;
    height: 100%;

}
</style>
